import { getWebsitePages } from 'src/editor/api/website-pages-api'
import { GetWebsitePagesResponse } from 'src/editor/store/website-pages/website-pages-types'
import { BaseQueryWithValidationClass } from './utils/query-with-validation-class'

class WebsitePagesQueryClass extends BaseQueryWithValidationClass<
  [number],
  GetWebsitePagesResponse
> {
  queryFn = (websiteId: number) => getWebsitePages(websiteId)
  getQueryKey = (websiteId: number) => ['websiteTheme', websiteId] as const
}

export const websitePagesQuery = new WebsitePagesQueryClass()
